"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
const material_1 = require("@mui/material");
exports.Root = (0, material_1.styled)(material_1.Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: 100,
    height: "100%",
    width: "100%",
});
//# sourceMappingURL=styled.js.map